import React from "react";
import { Gallery } from "./features/sections";
import "./App.scss";

function App() {
  return <Gallery />;
}

export default App;
